import React from "react";
import InputFieldForLots from "../offerComponents/InputFieldForLots";


function SelectBids({ setAuctionDetails, auctionDetails }) {
  return (
    <div className="pin-top" style={{ marginRight: "1.2rem" }}>
      <InputFieldForLots
        label={"Bids Validation"}
        type={"number"}
        name={"bidValidity"}
        placeholder={"Enter days"}
        value={auctionDetails?.bidValidity}
        setCreateOffer={setAuctionDetails}
      />
    </div>
  );
}

export default SelectBids;